var implementation = {exports: {}};

export { implementation as __module };
